"use client";

import { PageDecorLayer } from "@/components/decorative/PageDecorLayer";
import { LeadershipCard } from "@/components/about/LeadershipCard";
import { AnimatedSectionHeader } from "@/components/typography/AnimatedSectionHeader";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";
import type { AboutLeadershipContent } from "@/lib/api-types";

interface AboutLeadershipSectionProps {
  leadership: AboutLeadershipContent;
}

export function AboutLeadershipSection({
  leadership,
}: AboutLeadershipSectionProps) {
  const members = [...leadership.members]
    .filter((m) => m.published)
    .sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <section className="site-section relative bg-[var(--site-surface-alt)]">
      <PageDecorLayer variant="section" palette="site" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <AnimatedSectionHeader
            kineticTrigger="mount"
            title={leadership.title}
            subtitle={leadership.subtitle}
          />
        </Reveal>
        <Stagger className="mx-auto grid max-w-6xl gap-6 md:grid-cols-2 md:gap-6 lg:grid-cols-4 lg:gap-5">
          {members.map((member) => (
            <StaggerItem key={member.id}>
              <LeadershipCard
                member={{
                  name: member.name,
                  role: member.role,
                  bio: member.bio,
                  image: member.image,
                }}
              />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
